import { TypeFeatures } from "shared/utils/hooks/useFeature";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import { captureException, captureMessage } from "@sentry/nextjs";

export const usePlanFeature = (featureKey: TypeFeatures) => {
  let isFeatureEnabled = false;
  const {
    state: { tenancy },
  } = useGlobalContext();

  try {
    const feature = tenancy?.plan?.features?.find(
      (feature) => feature?.key === featureKey,
    );

    isFeatureEnabled = feature?.value === 1;
  } catch (error) {
    console.log("Erro (usePlanFeature): ", error);
    captureException(error);
    captureMessage("Erro (usePlanFeature)");
  }

  return isFeatureEnabled;
};
